import './App.css';
import { Weather } from "./components/weatherComponent";

function App() {
  return (
    <div className="App">
      <Weather />
    </div>
  );
}

export default App;
